import { ActionCardModel } from '@playbooks/action-cards-utils'
import { WidgetType } from '@playbooks/core/src/interfaces/ActionCard'

export default class ActionCardReplacementsProcessor {
  actionCardModel: ActionCardModel

  // Indicates whether the processor is being used in the context of a redirect link flow
  // To provide in the link parameter a raw markdown value instead of converting it to HTML from Generic Ai Widget
  redirectLinkFlow: boolean = false

  /**
   * Constructor for the ActionCardReplacementsProcessor.
   * @param actionCardModel The action card model to be used for replacements.
   * @param redirectLinkFlow Indicates whether the processor is being used in the context of a redirect link flow.
   *  To provide in the link parameter a raw markdown value instead of converting it to HTML from Generic Ai Widget
   */
  constructor(actionCardModel: ActionCardModel, redirectLinkFlow: boolean = false) {
    this.actionCardModel = actionCardModel
    this.redirectLinkFlow = redirectLinkFlow
  }

  process(template: string) {
    if (!this.actionCardModel?.replacementProcessor) {
      return template
    }

    if (this.redirectLinkFlow) {
      return this.actionCardModel.replacementProcessor.saveMarkdown().processReplacements(template)
    }

    return this.actionCardModel.replacementProcessor
      .skipElementTypes([WidgetType.GenericAiPrompt])
      .processReplacements(template)
  }
}
